import { writable } from 'svelte/store';

export interface BankAccountMetaData {
  institution: {
    name: string
  },
  accounts: [
    {
      id: number,
      mask: string,
      verification_status: string,
    }
  ],
  error_code: string
}

export interface BankAccountStore {
  plaid_items: PlaidItem[],
  loaded: boolean,
  failed: boolean
}

export interface PlaidItem {
  institution_name: string,
  plaid_accounts: PlaidAccount[]
}

export interface PlaidAccount {
  id: number,
  account_id: string,
  mask: string,
  verification_status: string,
  plaid_item_id: number,
  name: string,
  account_type: string,
  account_subtype: string
}

const defaultBankAccountStore: BankAccountStore = { plaid_items: [], loaded: false, failed: false };
export const bankAccount = writable<BankAccountStore>(defaultBankAccountStore);
export const updatingBankAccount = writable<boolean>(false)
